import { atom } from "recoil"

export const existingContactIdState = atom<string | undefined>({
  key: "atoms/contact/create/existingContactIdState",
  default: undefined,
})
